// extracted by mini-css-extract-plugin
export var modal = "_tc-0";
export var table = "_tc-1";